import { HTML_ENTITY_DECODE_FALLBACKS } from './sanitizeRichTextHtml';

const SCRIPT_OR_STYLE_BLOCK_PATTERN = /<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi;
const LINE_BREAK_TAG_PATTERN = /<br\s*\/?>|<\/p>/gi;
const HTML_TAG_PATTERN = /<[^>]*>/g;
const WHITESPACE_RUN_PATTERN = /\s+/g;

/**
 * Text-only version of rich text HTML, for renders that cannot run DOMPurify
 * (the server has no DOM). Render the result as a React text node, never as
 * HTML. It uses no DOM, so the server and the first client render produce the
 * same string and hydration matches.
 */
export const richTextHtmlToPlainText = (raw: string): string => {
  const decoded = HTML_ENTITY_DECODE_FALLBACKS.reduce(
    (text, [pattern, replacement]) => text.replace(pattern, replacement),
    raw,
  );

  return decoded
    .replace(SCRIPT_OR_STYLE_BLOCK_PATTERN, '')
    .replace(LINE_BREAK_TAG_PATTERN, ' ')
    .replace(HTML_TAG_PATTERN, '')
    .replace(WHITESPACE_RUN_PATTERN, ' ')
    .trim();
};
